import { useCallback, useState } from "react";
import styles from "../../FinancePage.module.css";
import { useFinanceStore } from "../../store/financeStore";
import { Step1Welcome } from "./Step1Welcome";
import { Step2ConnectMeta } from "./Step2ConnectMeta";
import { Step3Dropi } from "./Step3Dropi";
import { Step4FixedCosts } from "./Step4FixedCosts";
import { Step4Activating } from "./Step4Activating";

type OnboardingFlowProps = {
  initialStep?: 1 | 2 | 3 | 4 | 5;
  finishAfterFixedCosts?: boolean;
  onFinished?: () => void;
};

export const OnboardingFlow = ({
  initialStep = 1,
  finishAfterFixedCosts = false,
  onFinished,
}: OnboardingFlowProps) => {
  const [step, setStep] = useState(initialStep);
  const {
    metaConnected,
    dropiConnected,
    setMetaConnected,
    setDropiConnected,
    completeOnboarding,
  } = useFinanceStore();

  const handleDone = useCallback(async () => {
    await completeOnboarding();
    onFinished?.();
  }, [completeOnboarding, onFinished]);

  return (
    <div className={`${styles.onboardingWrap} ${styles.onboardingShellWrap}`}>
      {step === 1 ? <Step1Welcome onNext={() => setStep(2)} /> : null}
      {step === 2 ? (
        <Step2ConnectMeta
          connected={metaConnected}
          onConnectionChange={setMetaConnected}
          onNext={() => setStep(3)}
        />
      ) : null}
      {step === 3 ? (
        <Step3Dropi
          connected={dropiConnected}
          onConnectionChange={setDropiConnected}
          onNext={() => setStep(4)}
        />
      ) : null}
      {step === 4 ? (
        <Step4FixedCosts onNext={() => (finishAfterFixedCosts ? onFinished?.() : setStep(5))} />
      ) : null}
      {step === 5 ? <Step4Activating onDone={handleDone} /> : null}
    </div>
  );
};
